import React from 'react';

export function VersePreviewList({ verses, ariaLabel = 'Verse text preview' }) {
  return (
    <ul
      aria-label={ariaLabel}
      style={{
        listStyle: 'none',
        margin: 0,
        padding: 0,
      }}
    >
      {verses.map((verse, index) => {
        const fullText = `${verse.ref} ${verse.text}`;
        return (
          <li
            key={`${verse.ref}-${index}`}
            title={fullText}
            aria-label={fullText}
            style={{
              overflow: 'hidden',
              padding: '4px 0',
              textOverflow: 'ellipsis',
              whiteSpace: 'nowrap',
            }}
          >
            <strong>{verse.ref}</strong> {verse.text}
          </li>
        );
      })}
    </ul>
  );
}
